import styled from 'styled-components';
import Button from '../shared/Button';

export const GetTermsButton = styled(Button)`
  padding: 0px 15px;
`;

export const WhyTermsChange = styled.div`
  color: ${(props: any) => props.theme.carvana.gray.dark};
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  margin: 0 auto;
  text-align: center;
  padding: 10px 0px 30px 0px;
`;
